enum MaturixTemperatureUnit {
  CELCIUS = 'celcius',
  FAHRENHEIT = 'fahrenheit',
}

export default MaturixTemperatureUnit
